import { render, staticRenderFns } from "./ModalFrame.vue?vue&type=template&id=f797801e&scoped=true"
import script from "./ModalFrame.vue?vue&type=script&lang=ts"
export * from "./ModalFrame.vue?vue&type=script&lang=ts"
import style0 from "./ModalFrame.vue?vue&type=style&index=0&id=f797801e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f797801e",
  null
  
)

export default component.exports